// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Fvyf273zLYg7cgE0ErB3 {
  width: 100%;
  display: flex;
  gap: 1px;
}

.msVisCoUmw7IQN9hsdpG {
  font-family: var(--font-stack-full-regular);
  padding: 4px 0;
  font-size: 14px;
  line-height: 24px;
  color: var(--grey-color-70);
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/DistributionLevel/DistributionLevel.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,QAAA;AACF;;AAEA;EACE,2CAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;AACF","sourcesContent":[".distributionLevelFactorScoreContainer {\n  width: 100%;\n  display: flex;\n  gap: 1px;\n}\n\n.distributionBelowText {\n  font-family: var(--font-stack-full-regular);\n  padding: 4px 0;\n  font-size: 14px;\n  line-height: 24px;\n  color: var(--grey-color-70);\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"distributionLevelFactorScoreContainer": `Fvyf273zLYg7cgE0ErB3`,
	"distributionBelowText": `msVisCoUmw7IQN9hsdpG`
};
export default ___CSS_LOADER_EXPORT___;
